/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyersectiondescription2Inputs */

const en_flyersectiondescription2 = /** @type {(inputs: Flyersectiondescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_flyersectiondescription2 = /** @type {(inputs: Flyersectiondescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Flyersectiondescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyersectiondescription2 = /** @type {((inputs?: Flyersectiondescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyersectiondescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyersectiondescription2(inputs)
	return de_flyersectiondescription2(inputs)
});
export { flyersectiondescription2 as "flyerSectionDescription" }